import { render, staticRenderFns } from "./TraceForm.vue?vue&type=template&id=4735a112"
import script from "./TraceForm.vue?vue&type=script&lang=js"
export * from "./TraceForm.vue?vue&type=script&lang=js"
import style0 from "./TraceForm.vue?vue&type=style&index=0&id=4735a112&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports